import { createFileRoute, redirect } from '@tanstack/react-router'
import { Login } from '../pages/Login'

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    try {
      // Pakai /api/users/me agar dapat data lengkap (termasuk desa.slug)
      const res = await fetch('/api/users/me', { credentials: 'include' })
      if (!res.ok) return
      const user = await res.json()
      if (!user) return
      // Sudah login — redirect berdasarkan role
      if (user.role === 'platform_admin' || user.is_qc) {
        throw redirect({ to: '/platform' })
      }
      const staffRoles = ['kepala_desa', 'sekretaris_desa', 'operator_desa']
      if (staffRoles.includes(user.role) && user.status === 'approved' && user.desa?.slug) {
        throw redirect({ to: `/desa/${user.desa.slug}/dashboard` as any })
      }
      if (user.status === 'pending' && !user.desa_id) {
        throw redirect({ to: '/pilih-desa' })
      }
      throw redirect({ to: '/parkir' })
    } catch (e) {
      if ((e as any)?.to) throw e
      // Gagal cek session — biarkan masuk ke halaman login
    }
  },
  component: Login,
})
